import { FC } from "react";

import { CollaboratorRole, CollaborationStatus, ICollaborator } from "../../../store/collaborators/types";
import RoleButton from "./RoleButton";
import Status from "./Status";

import styles from "./styles.module.scss";

interface IProps {
    id: ICollaborator["id"];
    email: ICollaborator["email"];
    status?: CollaborationStatus;
    role: CollaboratorRole;
    scrolled: boolean;
    clearScrolled: () => void;
}

const Collaborator: FC<IProps> = ({ id, email, status, role, scrolled, clearScrolled }) => {
    return (
        <div className={styles.collaborator}>
            <div className={styles.info}>
                <span className={styles.email}>{email}</span>

                {status && <Status status={status} />}
            </div>

            <RoleButton id={id} role={role} scrolled={scrolled} clearScrolled={clearScrolled} />
        </div>
    );
};

export default Collaborator;
